import { StubModule } from "../../../shared/components/StubModule";
import { useConnectAction } from "../../../services/auth/useConnectAction";

interface LogoCloudModuleProps {
  readonly onBack?: () => void;
  readonly onOpenSettings?: () => void;
}

export function LogoCloudModule({
  onBack,
  onOpenSettings,
}: Readonly<LogoCloudModuleProps> = {}) {
  const connectAction = useConnectAction("logocloud", "Connect LogoCloud");
  return (
    <StubModule
      title="LogoCloud"
      subtitle="Brand-approved logo library"
      noticeTitle="Connect LogoCloud to continue"
      noticeMessage="LogoCloud uses AWS Cognito (us-east-1) with a brand-approved logo store."
      features={[
        "Browse the approved logo catalogue",
        "Filter by brand, region, and format",
        "Insert logos directly into the active document or slide",
        "Per-region API routing (eu-west-2)",
      ]}
      onBack={onBack}
      connectAction={connectAction}
      onOpenSettings={onOpenSettings}
    />
  );
}
